import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { mergeHomeSectionsState } from "@/lib/home-summary-state.js";

const useHomeStore = create(
  devtools(
    (set, get) => ({
      /** Section-keyed home summary data (metrics, assetGroupDistribution, …). */
      data: null,
      loading: false,
      error: null,
      lastUpdated: null,

      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),

      /** Merge a (partial) sections payload; absent sections are preserved. */
      mergeSections: (partial) => {
        set(mergeHomeSectionsState(get().data, partial));
      },

      reset: () => {
        set({
          data: null,
          loading: false,
          error: null,
          lastUpdated: null,
        });
      },
    }),
    {
      name: "home-store",
    }
  )
);

export { useHomeStore };
